import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import payresult from '@/components/payresult'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/payresult',
      name: 'payresult',
      component: payresult
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js